import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// MUI v5 theme system
import { ThemeProvider as MaterialThemeProvider, createTheme } from '@mui/material/styles';

// ⬅ The critical fix: StylesProvider is required to pass theme to @mui/styles
import { StylesProvider, ThemeProvider as LegacyThemeProvider } from '@mui/styles';

const theme = createTheme(); // now includes theme.spacing()

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <MaterialThemeProvider theme={theme}>
    <StylesProvider injectFirst>
      <LegacyThemeProvider theme={theme}>
        <App />
      </LegacyThemeProvider>
    </StylesProvider>
  </MaterialThemeProvider>
);

reportWebVitals();
